<template>
    <customer-filter v-if="showDialog && clue"
                     :show-dialog = "showDialog"
                     :filterIsBind="true"
                     :default-province="clue.province_id"
                     :default-city="clue.city_id"
                     :default-district="clue.district_id"
                     :clue="clue"
                     @filterCallback="watchFilterCallback"
                     @watchModalClose="watchModalClose"
    ></customer-filter>
</template>
<script>
import ClueService from "~/services/SaleClues"
import CustomerFilter from "~/widgets/CustomerFilter.vue";
export default {
    data() {
        return {
            showCustomerFilter: false,
            isShow: false,
            clueIds: [],
            submiting: false,
            // check_status: false,//校验是否有标记线索真实性，没有标记则跳出提示，不允许关联客户
        }
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true
        },

        // 线索记录模型
        clue: {
            type: Object,
            default: null,
            required: true
        }
    },
    watch: {
        showDialog: function(value, original) {
            this.isShow = value;
        }
    },
    components: {
        CustomerFilter
    },

    created() {
        // if(this.clue.status == 0){
        //     this.check_status = false;
        //     this.$confirm('关联客户前，请先标记线索真实性', '提示', {
        //         confirmButtonText: '去标记',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         if (this.$route.path != '/sales-leads/view'){
        //             let routeData = this.$router.resolve({
        //                 path: "/sales-leads/view",
        //                 query: {id: this.clue.id, check_status: this.clue.id},
        //             });
        //             window.open(routeData.href, '_blank');
        //         }else{
        //             this.$emit("checkStatus", []);
        //         }
        //     }).catch(() => {

        //     });
        // }else{
        //     this.check_status = true;
        // }
    },
    methods: {
        close() {
            this.isShow = false;
            this.submiting = false;
            this.$emit("changeShow", this.isShow);
        },

        handleClose() {
            this.close();
        },

        submitForm() {
            this.$refs["form"].validate(valid => {
                if(this.myClueId) {
                    this.clueIds.push(this.myClueId);
                }
                let params = {
                    customer_id: this.form.customer_id,
                    leads_ids: this.clueIds
                }
                if(valid) {
                    this.submiting = true;
                    ClueService.customerBind(params).then( res => {
                        this.submiting = false;
                        if(res.code == 0) {
                            this.$message({
                                type: "success",
                                message: "关联成功"
                            });
                            this.close();
                            this.$refs["form"].resetFields();

                            this.$router.push({
                                path: "/customers/view",
                                query: {
                                    id: params.customer_id
                                }
                            });
                            //this.$emit("saveCallback");
                        }
                    }).catch(err => {
                        this.submiting = false;
                        console.error(err);
                    })
                }
            })
            this.clueIds = [];
        },

        watchFilterCallback(customer, sub_type = 0) {
            ClueService.customerBind({
                customer_id: customer.id,
                leads_ids: [this.clue.id],
                sub_type: sub_type
            }).then(res => {
                this.submiting = false;
                if (res.code == 0) {
                    this.$message({
                        type: "success",
                        message: "关联成功"
                    });

                    this.close();

                    this.$router.push({
                        path: "/customers/view",
                        query: {
                            id: customer.id
                        }
                    });
                    //this.$emit("saveCallback");
                }
            }).catch(err => {
                console.error(err);
            })
        },

        watchModalClose (isShow) {
            this.close();
            this.$emit("checkStatus", []);
        },
    }
}
</script>




// WEBPACK FOOTER //
// src/views/clue/dialog/contactCustomerDialog.vue